import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Header from "../../Common/Layout/Header";
import VisaAPIConfig from "../../Common/Configurations/VisaAPIConfig";
import moment from "moment";
import { getUserId } from "./userHelper";
import VisaTabs from "../AllTabs/VisaTabs";
export default function PendingPayments() {
  const [list, setList] = useState([]);
  const [selectedPayments, setSelectedPayments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(false);
  const [selectedVisaDetails, setSelectedVisaDetails] = useState([]);
  const headerconfig = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("userToken"),
      "Content-Type": "application/json",
    },
  };

  const getPendingPayments = () => {
    axios
      .get(
        VisaAPIConfig.APIACTIVATEURL +
          VisaAPIConfig.GETPENDINGPAYMENTSBYID +
          "?userId=" +
          getUserId(),
        { ...headerconfig }
      )
      .then((res) => {
        if (res.data.statusCode === 200) {
          setList(res.data.data);
          const initialSelectedPayments = res.data.data.map(
            (item) => item.visaRequestId
          );
          setSelectedPayments(initialSelectedPayments);
          fetchSelectedVisaDetails(initialSelectedPayments);
        }
      })
      .catch((error) =>
        console.error("Error fetching pending payments:", error)
      );
  };

  useEffect(() => {
    getPendingPayments();
  }, []);

  const handleCheckboxChange = (visaRequestId) => {
    const updatedSelectedPayments = selectedPayments.includes(visaRequestId)
      ? selectedPayments.filter((id) => id !== visaRequestId)
      : [...selectedPayments, visaRequestId];

    setSelectedPayments(updatedSelectedPayments);
    fetchSelectedVisaDetails(updatedSelectedPayments);
  };

  const fetchSelectedVisaDetails = async (selectedPayments) => {
    if (selectedPayments.length === 0) {
      setSelectedVisaDetails([]);
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(
        VisaAPIConfig.APIACTIVATEURL + VisaAPIConfig.GETMULTIPLEVISAREQUEST,
        selectedPayments,
        { ...headerconfig }
      );
      if (response.data.statusCode === 200) {
        setSelectedVisaDetails(response.data.data); // Only store checked visas
        console.log("Updated Selected Visa Details:", response.data.data);
      } else {
        console.error("Failed to fetch multiple visa request details");
      }
    } catch (error) {
      console.error("Error fetching multiple visa request details:", error);
    }
    setIsLoading(false);
  };

  // Calculate total amount for selected visas
  const totalAmount = selectedPayments.reduce((sum, visaRequestId) => {
    const visa = list.find((item) => item.visaRequestId === visaRequestId);
    return sum + (visa ? visa.totalPrice : 0);
  }, 0);

  // Calculate total amount for ALL visas
  const totalPriceOfAllVisas = list.reduce(
    (sum, visa) => sum + visa.totalPrice,
    0
  );

  // Handle Total button - Calls UpdateVisaRequests API
  const handleTotalPayments = async () => {
    if (selectedVisaDetails.length === 0) {
      alert("Please select at least one visa request.");
      return;
    }
    setProcessing(true);

    const paymentGatewayNo = "TEST_RAZORPAY_KEY";

    // Map over selectedVisaDetails to add updated fields
    const updatedVisaRequests = selectedVisaDetails.map((visaRequest) => ({
      ...visaRequest,
      visaRequestId: visaRequest.visaRequestId,
      visaId: visaRequest.visaId,
      visaName: visaRequest.visaName,
      countryName: visaRequest.countryName,
      pricePerApplicant: parseFloat(visaRequest.pricePerApplicant),
      netPrice: parseFloat(visaRequest.netPrice),
      serviceFee: parseFloat(visaRequest.serviceFee),
      gst: parseFloat(visaRequest.gst),
      totalPrice: parseFloat(visaRequest.totalPrice),
      travelDate: moment(new Date()).format("YYYY-MM-DD"),
      noOfApplicants: visaRequest.noOfApplicants,
      paymentGateway: "RAZORPAY",
      paymentGatewayNo: paymentGatewayNo,
      visaRequestStatus: "SUBMITTED",
      paymentStatus: "PAID",
    }));

    try {
      const updateResponse = await axios.put(
        VisaAPIConfig.APIACTIVATEURL + VisaAPIConfig.UPDATEMULTIPLEVISAREQUEST,
        updatedVisaRequests,
        { ...headerconfig }
      );

      if (updateResponse.data.statusCode === 200) {
        alert("Payments successfully updated!");
        getPendingPayments();
      } else {
        alert("Payment update failed.");
      }
    } catch (error) {
      console.error("Error updating payments:", error);
    }
    setProcessing(false);
  };
  return (
    <div id="layout-wrapper">
      <Header />
      <div className="vertical-overlay"></div>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            {/* Total Pay Button */}
            <div className="row mb-3">
              <div className="col-12 text-end">
                <div className="p-2">
                  <VisaTabs pageName="VISAPAYMENTS" />
                </div>
                {/* <button className="btn btn-info me-2" disabled={selectedPayments.length === 0} onClick={handleTotalPayments}>
                                    Pay Total ₹{totalAmount.toLocaleString()}
                                </button> */}
                <button
                  className="btn btn-info me-2"
                  disabled={selectedPayments.length === 0 || processing}
                  onClick={handleTotalPayments}
                >
                  {processing
                    ? "Processing..."
                    : `Pay Total ₹${totalAmount.toLocaleString()}`}
                </button>
              </div>
            </div>

            {/* Pending Payments Table */}
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Select</th>
                            <th>Reference No</th>
                            <th>Visa Name</th>
                            <th>Customer</th>
                            <th>Price</th>
                          </tr>
                        </thead>
                        <tbody>
                          {list.map((l) => (
                            <tr key={l.visaRequestId}>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={selectedPayments.includes(
                                    l.visaRequestId
                                  )}
                                  onChange={() =>
                                    handleCheckboxChange(l.visaRequestId)
                                  }
                                />
                              </td>
                              <td>{l.visaReferenceNo}</td>
                              <td>{l.visaName}</td>
                              <td>{l.customerName}</td>
                              <td>₹{l.totalPrice.toLocaleString()}</td>
                            </tr>
                          ))}
                          {/* Footer Row for Total Price */}
                          <tr>
                            <td colSpan="4" className="text-start">
                              <strong>Total Price:</strong>
                            </td>
                            <td>
                              <strong>
                                ₹{totalPriceOfAllVisas.toLocaleString()}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
